import * as React from 'react';

import { TrackedCdsButton } from 'bundles/common/components/withSingleTracked';
import type { AutocompleteMode } from 'bundles/search-common/constants/autocomplete';
import { type AutocompleteItems, getAutocompleteEventingData } from 'bundles/search-common/utils/autocomplete';

type Props = {
  autocompleteState: AutocompleteMode;
  id: string;
  recentlyViewedItems: AutocompleteItems;
  suggestionIndex: number;
  children: React.ReactNode;
};

const AutocompleteTrendingOption = ({
  autocompleteState,
  id,
  recentlyViewedItems,
  suggestionIndex,
  children,
}: Props) => {
  const eventingData = getAutocompleteEventingData(id, autocompleteState, recentlyViewedItems, suggestionIndex);

  return (
    <TrackedCdsButton
      variant="secondary"
      size="small"
      trackingName="click_autocomplete_suggestion"
      // @ts-expect-error: Type mismatch in TrackingData
      trackingData={eventingData}
    >
      {children}
    </TrackedCdsButton>
  );
};

export default AutocompleteTrendingOption;
